import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Table from "components/table/Table";
import { AddButton, MediumScreenModel } from "components";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import {featchSpecialOffer } from "../state/action";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { SuperAdminStatusEnum } from '../../../props/enum';
import { TableColumns } from "./components/TableColumns";
import HandleCreateSpecailOffer from "./HandleCreateSpecialOffer";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const SpecialOfferTable: React.FC<Props> = ({ onSpecialOffer, specialOfferState }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(!isModalOpen);
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onSpecialOffer();
  }, [onSpecialOffer]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_FEATURED_ADS));
  const specialOfferData = specialOfferState?.specialOffer;

  return (
    <div className="">
      <Table
        headers={["Special Offer"]}
        data={specialOfferData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add Special Offer"
                tooltip="Add new Special Offer"
              />
            )}
          </>
        }
      />
      <MediumScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <HandleCreateSpecailOffer onClose={closeModal} />
        </div>
      </MediumScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    specialOfferState: state.fetchSpecialOfferReducer?.specialOfferState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onSpecialOffer: () => dispatch(featchSpecialOffer()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOfferTable);
